import $ from 'jquery';

// --------------------------------------------------
// Tabbed Content
// Button switcher for the Tabbed Content page-builder component. Clicking a
// tab button reveals its panel and hides the others. Follows the WAI-ARIA
// tabs pattern: roving tabindex, Left/Right (and Home/End) arrow keys move
// between tabs. Supports multiple sections on a page. Progressive — with JS
// off, every panel stays visible.
// --------------------------------------------------

$(function () {
  $('[data-tabbed-content]').each(function () {
    const root = this;
    const tabs = Array.from(root.querySelectorAll('[data-tabbed-content-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-tabbed-content-panel]'));

    if (tabs.length < 2) {
      return;
    }

    function activate(index, setFocus) {
      tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (active && setFocus) {
          tab.focus();
        }
      });

      panels.forEach((panel, i) => {
        const active = i === index;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activate(i, false));

      tab.addEventListener('keydown', (e) => {
        let next = null;

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          next = (i + 1) % tabs.length;
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          next = (i - 1 + tabs.length) % tabs.length;
        } else if (e.key === 'Home') {
          next = 0;
        } else if (e.key === 'End') {
          next = tabs.length - 1;
        }

        if (next !== null) {
          e.preventDefault();
          activate(next, true);
        }
      });
    });
  });
});
